module["exports"] = ["Արցախի Հանրապետություն"];